import React from "react";

export default function ModerationOverlay () {
    return (
    <div className="discussionmoderation-overlay">
        <div className="discussionmoderation-popup">
            <p className="R14_61" id="disModMsg"></p>  <hr></hr>
            <a href="https://parenting.firstcry.ae/discussions" className="M15_pink">OK</a>
        </div>
    </div>
    );
}


// WEBPACK FOOTER //
// src/shared/discussions/common/ModerationOverlay.js